import { useNostr } from '@nostrify/react';
import { useQuery } from '@tanstack/react-query';
import { Deck, DECK_KIND, isDeckEvent, transformDeckEvent } from '@/lib/nostr/deck';
import { useCurrentUser } from './useCurrentUser';

export function useCardLists(pubkey: string) {
  const { nostr } = useNostr();
  const { user } = useCurrentUser();

  return useQuery<Deck[]>({
    queryKey: ['card-lists', pubkey],
    queryFn: async ({ signal }) => {
      if (!pubkey) return [];

      const events = await nostr.query(
        [{
          kinds: [DECK_KIND],
          authors: [pubkey],
        }],
        { signal }
      );

      return events
        .filter(isDeckEvent)
        .map(transformDeckEvent)
        .filter(deck => {
          const isUnlisted = deck.event.tags.some(t => t[0] === 't' && t[1] === 'unlisted');
          if (isUnlisted && deck.event.pubkey !== user?.pubkey) {
            return false;
          }
          return true;
        });
    },
    enabled: !!pubkey,
  });
}
